import { isAxiosError } from 'axios';

export function getApiErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    const msg = (error.response?.data as { error?: { message?: string } } | undefined)?.error?.message;
    if (typeof msg === 'string' && msg.trim()) return msg;
  }
  if (error instanceof Error && error.message.trim()) return error.message;
  return fallback;
}

async function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ''));
    reader.onerror = () => reject(reader.error ?? new Error('read-failed'));
    reader.readAsDataURL(file);
  });
}

export async function prepareImageForUpload(file: File): Promise<{ dataBase64: string; contentType: string }> {
  const MAX_SIDE = 1200;
  const jpegQuality = 0.76;
  const dataUrl = await fileToDataUrl(file);
  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error('Не удалось прочитать изображение. Попробуйте JPG/PNG/WEBP.'));
    image.src = dataUrl;
  });

  const scale = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
  const width = Math.max(1, Math.round(img.width * scale));
  const height = Math.max(1, Math.round(img.height * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Не удалось подготовить изображение.');
  ctx.drawImage(img, 0, 0, width, height);
  const outputType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
  const encoded = canvas.toDataURL(outputType, outputType === 'image/jpeg' ? jpegQuality : undefined);
  const dataBase64 = encoded.includes(',') ? encoded.split(',')[1] : '';
  if (!dataBase64) throw new Error('Не удалось преобразовать изображение.');
  return { dataBase64, contentType: outputType };
}

export const emptyCompositionRow = { name: '', quantity: 1 };

